import { render, staticRenderFns } from "./Decs.vue?vue&type=template&id=baaeeada&"
import script from "./Decs.vue?vue&type=script&lang=js&"
export * from "./Decs.vue?vue&type=script&lang=js&"
import style0 from "./Decs.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports